import { render, staticRenderFns } from "./ProcessorsStatusLabel.vue?vue&type=template&id=320fe2a2"
import script from "./ProcessorsStatusLabel.vue?vue&type=script&lang=js"
export * from "./ProcessorsStatusLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports